@if (isLoading) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <body class="rounded-l-3xl min-h-screen flex flex-col">
    <button
      class="absolute top-2 right-2 z-50 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
      (click)="dialogRef.close()" aria-label="Fermer" style="font-size: 2rem; width: 44px; height: 44px;">
      <span class="material-symbols-outlined">close</span>
    </button>
    <main class="flex-1 bg-grayNovo">
      <div class="flex-grow flex text-center mb-2 items-center justify-center overflow-visible">
        <img alt="img" class="w-full h-full object-cover h-2/10"
          [src]="getLocalizedContent(scormPackage.locales).thumbnail"
          [alt]="getLocalizedContent(scormPackage.locales).titre + ' thumbnail'">
        </div>
        <div class="p-2">
        </div>
        <div class="text-center object-cover h-1/10 ml-3 mr-3 mb-2">
          @if (scormPackage.progression === eProgressionPaquet.NonCommence) {
            <div class="items-center space-x-1 justify-center"
              >
              <div class="material-symbols-outlined text-[15px] icon-small">stop_circle</div><span class="p-0">{{
            'SCORMS_LIST.NO_START' | translate }}</span>
            <div>
              <button class="btn-primary-novo button-lg" MatButton (click)="startScorm(scormPackage.scormPackageId)"
              #startButton>{{ 'SCORMS_LIST.START' | translate }}</button>
            </div>
          </div>
        }
        @if (scormPackage.progression === eProgressionPaquet.EnCours) {
          <div class="items-center space-x-1 justify-center"
            >
            <div class="material-symbols-outlined text-[15px] icon-small">pause</div><span class="p-0">{{
          'SCORMS_LIST.PAUSE' | translate }}</span>
          <div>
            <button class="btn-primary-novo button-lg" MatButton
              (click)="startScorm(scormPackage.scormPackageId, scormPackage.sessionId)" #startButton>{{
            'SCORMS_LIST.CONTINUE' | translate }}</button>
          </div>
        </div>
      }
      @if (scormPackage.progression === eProgressionPaquet.Complete) {
        <div class="items-center space-x-1 justify-center"
          >
          <div class="material-symbols-outlined text-[15px] icon-small">check_circle</div><span class="p-0">{{
        'SCORMS_LIST.FINISH' | translate }}</span>
        <div class="flex flex-col gap-2 items-center">
          <button class="btn-primary-novo button-lg" MatButton (click)="startScorm(scormPackage.scormPackageId)"
          #startButton>{{ 'SCORMS_LIST.RESTART' | translate }}</button>
          @if (!scormPackage.estFormationGroupe) {
            <button class="btn-secondary-novo button-lg" MatButton
              (click)="previewScorm(scormPackage.scormPackageId)">{{
            'SCORMS_LIST.PREVIEW' | translate }}</button>
          }
        </div>
      </div>
    }
  </div>
  <div class="object-cover h-6/10 pl-3 pr-3">
    <div class="text-center">
      <p class="titre2" [innerHtml]="getLocalizedContent(scormPackage.locales).titre"></p>
    </div>
    <div class="text-center">
      <div> <span innerHTML="{{getsubtitle()}}"></span></div>
      <div class="text-green-500"> <span innerHTML="{{getLocalizedEvaluationCritere()}}"></span></div>
    </div>
    @if (scormConfig) {
      <div class="flex flex-col ml-4">
        <div #descriptionContainer [innerHTML]="getLocalizedDescription() | SanitizeHtml"></div>
        <div class="flex items-center space-x-1"><span
          class="material-symbols-outlined text-[15px] mb-1 icon-small">timer</span><span>{{getdurationInMinutes()}}</span>
          <span class="mr-1">{{ 'SCORMS_LIST.DURATION' | translate }}</span>
        </div>
      </div>
    }
  </div>
</main>
<div class="w-full bg-[#424242] p-4">
  <div class="flex items-start gap-6">
    <div class="flex items-start gap-6">
      @if (scormPackage.donneCertificat) {
        <div class="flex flex-col items-center" [class.cursor-pointer]="!estDemo"
          [class.cursor-not-allowed]="estDemo" [class.opacity-50]="estDemo"
          [title]="estDemo ? ('SCORMS_LIST.DEMO_CERTIFICATE_DISABLED' | translate) : ''"
          (click)="isAccesDownloadCertificat()">
          <span class="material-symbols-outlined icon-large">workspace_premium</span>
          <label class="mt-1 text-center">{{ 'SCORMS_LIST.ATTESTATION' | translate }}</label>
        </div>
      }
      @if (references) {
        @for (reference of references; track reference) {
          <div class="flex flex-col items-center cursor-pointer"
            (click)="downloadRapportFormation(scormPackage.scormPackageId, reference)">
            <span class="material-symbols-outlined icon-large">picture_as_pdf</span>
            <label class="mt-1 text-center">{{ getLocalizedDocumentreferenceContent(reference) }}</label>
          </div>
        }
      }
      @if (attachedDocuments?.length) {
        @for (document of attachedDocuments; track document) {
          <div class="flex flex-col items-center cursor-pointer"
            (click)="downloadAttachedDocument(document)">
            <span class="material-symbols-outlined icon-large">{{ getAttachedDocumentIcon(document) }}</span>
            <label class="mt-1 text-center">{{ getAttachedDocumentLabel(document) }}</label>
          </div>
        }
      }
    </div>
  </div>
</div>
</body>
}
